import { render, staticRenderFns } from "./DevolucionBodegaEditarValores.vue?vue&type=template&id=5f023036&scoped=true"
import script from "./DevolucionBodegaEditarValores.vue?vue&type=script&lang=js"
export * from "./DevolucionBodegaEditarValores.vue?vue&type=script&lang=js"
import style0 from "./DevolucionBodegaEditarValores.vue?vue&type=style&index=0&id=5f023036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f023036",
  null
  
)

export default component.exports